import React, { FC } from 'react';
import { Input, Form } from 'antd';
import styled from 'styled-components';
import FormItem from 'antd/lib/form/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import { Button3D} from './Button3D';
import { ExpertText, MediumHeaderTitle } from './Text3D';


const FormWrapper = styled.div`
    display: flex;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);


`;
const FormStyle = styled(Form)`
width: 80%;
display: flex;
flex-direction: column; 
margin: 0 auto;
`;
const InputX = styled(Input)`
height: 50px;
margin-top: 5px;
`;

const FormContact3D: FC = () => {
    return (
        <>
            <FormWrapper>
                <Form style={{}}>
                    <FormStyle>
                    <MediumHeaderTitle fontSize dark style={{marginTop: '1rem'}}>GET IN TOUCH WITH US</MediumHeaderTitle>
                    <ExpertText dark>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt, perspiciatis.</ExpertText>
                        <FormItem style={{marginTop:'10px'}}>
                            <label htmlFor="name">Name *</label>
                            <InputX placeholder='Enter Your Name' />
                        </FormItem>
                        <FormItem>
                            <label htmlFor="email">Email *</label>
                            <InputX type='email' placeholder='Enter Your Email' />
                        </FormItem>
                        <FormItem>
                            <label htmlFor="password">Company</label>
                            <InputX type='password' placeholder='Enter Your Company name' />
                        </FormItem>
                        <FormItem>
                            <label htmlFor="name">Massage</label>
                            <TextArea autoSize={{minRows:3, maxRows:5}} placeholder='Write Your Massage' style={{marginTop:'5px'}} />
                        </FormItem>
                        <FormItem style={{marginTop:'1rem'}}>
                            <Button3D style={{backgroundColor:'#1196DD', border:'none',color:'white'}}>GET STARTED</Button3D>
                        </FormItem>
                    </FormStyle>
                </Form>
            </FormWrapper>
        </>
    );
}
export default FormContact3D;